import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import './index.scss';
import { Flex } from '@magnetic/flex';
const Header = ({ children }) => {
    return (_jsx("div", Object.assign({ className: "header-container" }, { children: _jsx(Flex, Object.assign({ gap: 24 }, { children: children })) })));
};
export default Header;
